import type { TNullable } from '@/infra/types/common';

export const getBarTabText = (
  text: TNullable<string> | undefined,
  dynamicValue: TNullable<string> | undefined,
): string | undefined => {
  const isDynamic = text?.includes('{N}');

  if (isDynamic && dynamicValue && text) {
    return text.replace('{N}', dynamicValue);
  } else if (!isDynamic && text) {
    return text;
  }
};
